import type {
  BookingStop,
  JobBookingCustomer,
} from '@/models/advancedJobBooking';

/** A single box-type + qty line for delivering empty boxes to a farm. */
export interface BookBoxesProduct {
  model: string | null;
  model_id: number | null;
  quantity: number;
  description: string;
}

export function createEmptyBookBoxesProduct(): BookBoxesProduct {
  return { model: null, model_id: null, quantity: 1, description: '' };
}

// TODO: replace with openapi.PostBookBoxesJobBookApi_Body once the backend adds the endpoint.
export interface BookBoxesJobBookApiBody {
  customer_code: string;
  caller: string;
  phone: string;
  REF1: string;
  REF2: string;
  REF3: string;
  stops: BookingStop[];
  products: BookBoxesProduct[];
}

export function buildBookBoxesJobBookApiBody(
  customer: JobBookingCustomer,
  stops: BookingStop[],
  products: BookBoxesProduct[],
): BookBoxesJobBookApiBody {
  return {
    customer_code: customer.customer_code ?? '',
    caller: customer.caller,
    phone: customer.phone,
    REF1: customer.REF1,
    REF2: customer.REF2,
    REF3: customer.REF3,
    stops,
    products,
  };
}
